//----this is playlist pitchment---

import "./rights.scss";
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Grid,
  InputLabel,
  TextField,
  Box,
  withStyles,
  Button,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Chip,
} from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import {
  API_URL,
  guidelinesTools,
  guidelinesToolsLyrics,
  trackTitleLanguage,
} from "../../constants";
import SelectCmp from "react-select";
import SaveIcon from "@material-ui/icons/Save";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CustomShowModal from "../../components/Common/CustomShowModal";
import { useLocation } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import Instagram from "@material-ui/icons/Instagram";
import Facebook from "@material-ui/icons/Facebook";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { getHeaders, toastError, toastSuccess } from "../../utils";
import * as actions from "./actions";
import axios from "axios";
const selectStyles = {
  control: (base, state) => ({
    ...base,
    border: `1px solid ${state.isFocused ? "#00a1ff" : "#767676"} `,
    boxShadow: "none",
    background: "transparent",
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#9f9f9f",
      fontFamily: `"DM Sans", sans-serif`,
    };
  },
};

const whitelistPlatformOptions = [
  { value: "Youtube", label: "Youtube" },
  { value: "Soundcloud", label: "Soundcloud" },
];

const whitelistchannelOptions = [
  { value: "Artist Channel", label: "Artist Channel" },
  { value: "Label Channel", label: "Label Channel" },
];

const platformOptions = [
  { value: "Youtube Content ID", label: "Youtube Content ID" },
];

const policyOptions = [
  { value: "Monetize", label: "Monetize" },
  { value: "Remove", label: "Remove" },
  { value: "Block", label: "Block" },
];

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const moodsOptions = [
  "Chill",
  "Motivation",
  "Happy",
  "Energetic",
  "Sad",
  "Romantic",
  "Sexy",
  "Spirtual",
  "Relax",
  "None of these",
];

const StyledButton = withStyles({
  root: {
    fontFamily: "'DM Sans', sans-serif",
    background: "#2d2d2d",
    fontSize: 14,
    height: 35,
    width: 150,
    borderColor: "#0597b2",
    margin: "auto",
    color: "white",
    "&:hover": {
      color: "black",
      border: "1px solid black",
    },
  },
  label: {
    textTransform: "capitalize",
  },
})(Button);

const CssTextField = withStyles({
  root: {
    // background: "transparent",
    fontFamily: "'DM Sans', sans-serif",
    color: "#fff",
    "& label": {
      fontFamily: "'DM Sans', sans-serif",
      // color: '#10baa8',
      color: "white",
    },
    "& label.Mui-focused": {
      // color: '#10baa8',
      color: "white",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "red",
    },
    "& .MuiOutlinedInput-root": {
      // '& fieldset': {
      // borderColor: 'white',
      // },
      // '&:hover fieldset': {
      // borderColor: 'white',
      // },
      "&.Mui-focused fieldset": {
        borderColor: "#10baa8",
        borderWidth: "1px",
      },
    },
  },
})(TextField);

const intitalUGCState = {
  release_id: "",
  release_title: "",
  audio_title: "",
  platform: "",
  policy: "",
  url: [], // multi url
};

const initialWhitelistState = {
  whitelist_id: "",
  platform: "",
  channel_type: "",
  channel_name: "",
  URL: "",
};

const intitalProfileState = {
  release_id: "",
  release_title: "",
  audio_title: "",
  artist: "",
  facebook_link: "", // single url
  instagram_link: "", // single url
};

const intitalPlaylistState = {
  release_id: 1,
  release_title: "",
  audio_title: "",
  press_release: [], // multi url
  social_media: [], // multi url
  artwork_asset: "", // single url
  additional_assets: "", // single url
  moods: [], // multi url
  why_pitch: "",
  quick_pitch: "",
  additional_info: "",
};

function isValidUrl(str) {
  const pattern = new RegExp(
    "^([a-zA-Z]+:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR IP (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$", // fragment locator
    "i"
  );
  return pattern.test(str);
}

export default function RightsManager(props) {
  const { setLoader = () => {} } = props;
  const { pathname } = useLocation();

  const [toolType, setToolType] = useState("ugc"); // ugc, profile, playlist
  const [releases, setReleases] = useState([]);
  const [songs, setSongs] = useState([]);
  const [dataHistory, setDataHistory] = useState([]);
  const [guidelinesOpen, setGuidelinesOpen] = useState(false);
  const [selectedRelease, setSelectedRelease] = useState(null);
  const [selectedSong, setselectedSong] = useState(null);
  const [data, setData] = useState(JSON.parse(JSON.stringify(intitalUGCState))); // deep clone
  const [modalViewType, setModalViewType] = useState({
    type: "",
    urls: [],
  }); // url, press, social, moods, facebook, instagram,  artwork, additional,
  const [modalContentView, setModalContentView] = useState({
    show: false,
    component: null,
  });
  const [viewDetailsModal, setViewDetailsModal] = useState(null);
  const [detailsData, setDetailsData] = useState();
  const [count, setCount] = useState(0);
  const [filters, setFilters] = useState({
    limit: 20,
    offset: 0,
    page: 1,
  });
  const [lyricalData, setLyricalData] = useState({});

  useEffect(() => {
    setInitialData();
  }, [pathname]);

  useEffect(() => {
    onGetSongsByRelease();
  }, [selectedRelease]);

  let guidelinesToolsArray = "";
  if (toolType === "playlist") {
    guidelinesToolsArray = guidelinesTools;
  } else guidelinesToolsArray = guidelinesToolsLyrics;

  const setInitialData = async () => {
    try {
      let toolTypePath = "ugc";
      if (pathname === "/rights/whitelist") {
        toolTypePath = "whitelist";
        setData(JSON.parse(JSON.stringify(initialWhitelistState)));
      } else {
        toolTypePath = "ugc";
        setData(JSON.parse(JSON.stringify(intitalUGCState)));
      }
      setToolType(toolTypePath);
      if (toolTypePath !== toolType) {
        setDataHistory(null);
      }
      getInitialData(toolTypePath, filters);
      setSelectedRelease(null);
      setselectedSong(null);
    } catch (ex) {
      setLoader(false);
    }
  };

  const getInitialData = async (toolType, filters = {}) => {
    try {
      let releaseActions = Promise.resolve({});
      let historyAction = Promise.resolve({});
      if (toolType === "ugc") {
        releaseActions = actions.getReleaseTitles;
        historyAction = actions.getUGCClaimHistory;
      } else if (toolType === "whitelist") {
        releaseActions = actions.getReleaseTitles;
        historyAction = actions.getWhitelistHistory;
      }
      setLoader(true);
      const [{ body: releases = [] }, { body: dataHistory = [], total = 0 }] =
        await Promise.all([releaseActions(), historyAction(filters)]);
      setReleases(
        releases.map((item) => ({
          ...item,
          label: item.release_title,
          value: item.release_id,
        }))
      );
      setCount(total);
      setDataHistory(dataHistory);
      setLoader(false);
    } catch (ex) {
      setLoader(false);
    }
  };

  const onGetSongsByRelease = async () => {
    try {
      if (!selectedRelease.release_id) return;
      setSongs([]);
      setselectedSong(null);
      setLoader(true);
      const { body: songs = [] } =
        (await actions.getAudioTitlesByReleaseId(selectedRelease.release_id)) ||
        {};
      setSongs(
        songs.map((item) => ({
          ...item,
          label: item.title,
          value: item.audio_id,
        }))
      );
      setLoader(false);
    } catch (ex) {
      setLoader(false);
    }
  };

  const onPageChange = (event, page) => {
    const offset = (page - 1) * filters.limit;
    const newFilters = { ...filters, page, offset };
    setFilters(newFilters);
    getInitialData(toolType, newFilters);
  };

  const onHandleChange = (e = {}) => {
    const { name = "", value = "" } = e.target || {};
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const onHandleModalView = (type, urls = []) => {
    setModalViewType({
      type,
      urls: !urls.length && type !== "moods" ? [""] : urls,
    });
  };

  const onChangeUrls = (action, type, value, index) => {
    const updatedData = { ...data };
    if (type === "moods") {
      if (action === "update") {
        const prevdata = { ...modalViewType };
        prevdata.urls.push(value);
        setModalViewType(prevdata);
      } else {
        const updatedMoods = modalViewType.urls.filter(
          (item) => item !== value
        );
        setModalViewType((prev) => ({ ...prev, urls: updatedMoods }));
      }
    } else {
      if (action === "add") {
        setModalViewType((prev) => ({ ...prev, urls: [...prev.urls, ""] }));
        updatedData[type].push("");
      } else if (action === "delete") {
        const prevdata = { ...modalViewType };
        prevdata.urls.splice(index, 1);
        setModalViewType(prevdata);
      } else if (action === "update") {
        const prevdata = { ...modalViewType };
        prevdata.urls[index] = value;
        setModalViewType(prevdata);
      }
    }
  };

  const onAddUrls = () => {
    const { type, urls = [] } = modalViewType;
    if (type !== "moods") {
      if (!urls.length) return;
      for (let i = 0; i < urls.length; i++) {
        const isValid = isValidUrl(urls[i]);
        if (!isValid) {
          toastError(`Invalid URL at position ${i + 1}`);
          return;
        }
      }
    }
    const updatedData = { ...data };
    updatedData[type] = urls;
    setData(updatedData);
    setModalViewType({
      type: "",
      urls: [],
    });
  };

  const isValidLink = (text) => {
    try {
      const url = new URL(text);
      return ['http:', 'https:'].includes(url.protocol);
    } catch (err) {
      return false;
    }
  };

  const onSubmitForm = async () => {
    if (
      toolType !== "whitelist" &&
      (!selectedRelease || !selectedRelease?.label || !selectedSong?.label)
    ) {
      toastError(`Please fill all mandatory fields`);
      return;
    }
    try {
      let request = {};
      let sendObj =
        toolType !== "whitelist"
          ? {
              release_id: selectedRelease.value,
              release_title: selectedRelease.label,
              audio_title: selectedSong.label,
            }
          : {};

      if (toolType === "ugc") {
        if (
          !data.platform ||
          !selectedRelease ||
          !data.policy ||
          data?.url.length === 0 ||
          !sendObj.audio_title
        ) {
          toastError(`Please fill all mandatory fields`);
          return;
        }
        sendObj = {
          ...sendObj,
          platform: data.platform,
          policy: data.policy,
          url: data.url,
        };
        request = actions.submitUGCClaim;
      } else if (toolType === "whitelist") {
        if (
          !data.whitelistPlatform ||
          !data.channel_type ||
          !data.channel_name ||
          !data.URL
        ) {
          toastError(`Please fill all mandatory fields`);
          return;
        }
        if (!isValidLink(data.URL)) {
          toastError(`Please enter a valid link`);
          return;
        }
        sendObj = {
          platform: data.whitelistPlatform,
          channel_type: data.channel_type,
          channel_name: data.channel_name,
          URL: data.URL,
        };
        request = actions.submitWhitelist;
      }

      setLoader(true);
      await request(sendObj);
      setLyricalData({});
      setSelectedFileName("");
      await setInitialData();
      toastSuccess("Submission successful.");
    } catch (ex) {
      setLoader(false);
      toastError(ex.message);
    }
  };

  const renderModalViewContent = (renderType, content) => {
    let component = null;
    switch (renderType) {
      case "urls": {
        component = (
          <Box>
            {Array.isArray(content) && content.length
              ? content.map((item) => {
                  return (
                    <Box textAlign="center" mb={1}>
                      <a href={item} target="_blank">
                        {item}
                      </a>
                    </Box>
                  );
                })
              : null}
          </Box>
        );
        break;
      }
      case "": {
        // other cases
        component = <></>;
      }
      default:
        component = null;
    }
    setModalContentView({ show: true, component });
  };

  const selectedPolicy = useMemo(
    () => policyOptions.find((item) => item.value === data.policy),
    [data]
  );
  const selectedPlatform = useMemo(
    () => platformOptions.find((item) => item.value === data.platform),
    [data]
  );
  const selectedWhitelistPlatform = useMemo(
    () =>
      whitelistPlatformOptions.find(
        (item) => item.value === data.whitelistPlatform
      ),
    [data]
  );

  const selectedWhitelistChannel = useMemo(
    () =>
      whitelistchannelOptions.find((item) => item.value === data.channel_type),
    [data]
  );
  const heading = useMemo(() => {
    let heading = "UGC Claims";
    if (toolType === "whitelist") {
      heading = "Whitelist";
    }
    return heading;
  }, [toolType]);

  let totalPages = Math.ceil(Number(count) / filters.limit);

  const fileInputRef = useRef(null);
  const [selectedFileName, setSelectedFileName] = useState("");

  return (
    <Grid container className="tools-container">
      <p className="heading">{heading}</p>
      <Grid item xs={12}>
        {toolType === "ugc" && (
          <div className="ticket-info-tag">
            <p>
              <ErrorOutlineIcon /> Misuse of tool will result in suspension of
              the service. For more info please email us at
              support@fronicmedia.com
            </p>
          </div>
        )}
        {toolType === "whitelist" && (
          <div className="ticket-info-tag">
            <p>
              <ErrorOutlineIcon /> Misuse of tool will result in suspension of
              the service. The tool is currently in its Beta phase, so
              occasional issues may arise. For more please email at
              support@fronicmedia.com
            </p>
          </div>
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={8}
        style={{ margin: "auto", marginTop: "8px" }}
      >
        <Grid container className="input-field-container">
          {toolType !== "whitelist" && (
            <>
              <Grid item xs={12} sm={6}>
                <Box p={1}>
                  <InputLabel>
                    Select Release<span className="required-span">*</span>
                  </InputLabel>
                  <SelectCmp
                    styles={selectStyles}
                    options={releases}
                    value={selectedRelease}
                    placeholder="Select Release"
                    onChange={setSelectedRelease}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box p={1}>
                  <InputLabel>
                    Select Audio<span className="required-span">*</span>
                  </InputLabel>
                  <SelectCmp
                    styles={selectStyles}
                    options={songs}
                    value={selectedSong}
                    placeholder="Select Audio"
                    onChange={setselectedSong}
                  />
                </Box>
              </Grid>
            </>
          )}

          {toolType === "ugc" && (
            <>
              <Grid item xs={12} sm={6}>
                <Box p={1}>
                  <InputLabel>
                    Select Platform<span className="required-span">*</span>
                  </InputLabel>
                  <SelectCmp
                    styles={selectStyles}
                    value={selectedPlatform || null}
                    options={platformOptions}
                    placeholder="Select Platform"
                    onChange={(e) =>
                      onHandleChange({
                        target: { name: "platform", value: e.value },
                      })
                    }
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box p={1}>
                  <InputLabel>
                    Select Policy<span className="required-span">*</span>
                  </InputLabel>
                  <SelectCmp
                    styles={selectStyles}
                    value={selectedPolicy || null}
                    options={policyOptions}
                    placeholder="Select Policy"
                    onChange={(e) =>
                      onHandleChange({
                        target: { name: "policy", value: e.value },
                      })
                    }
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box p={1}>
                  <InputLabel>
                    URL<span className="required-span">*</span>
                  </InputLabel>
                  <span
                    style={{
                      color: "blue",
                      cursor: "pointer",
                      fontWeight: 500,
                    }}
                    onClick={() => onHandleModalView("url", data.url || [])}
                  >
                    {(data.url && data.url.length) || 0} URL added (Click to
                    add)
                  </span>
                </Box>
              </Grid>
            </>
          )}

          {/* ankush */}

          {toolType === "whitelist" && (
            <>
              <Grid item xs={12} sm={6}>
                <Box p={1}>
                  <InputLabel>
                    Select Platform<span className="required-span">*</span>
                  </InputLabel>
                  <SelectCmp
                    styles={selectStyles}
                    value={selectedWhitelistPlatform || null}
                    options={whitelistPlatformOptions}
                    placeholder="Select Platform"
                    onChange={(e) =>
                      onHandleChange({
                        target: { name: "whitelistPlatform", value: e.value },
                      })
                    }
                  />
                </Box>
                <Box p={1}>
                  <InputLabel>
                    Channel Name<span className="required-span">*</span>
                  </InputLabel>
                  <CssTextField
                    variant="outlined"
                    name="channel_name"
                    fullWidth
                    placeholder={`Enter the channel name`}
                    size="small"
                    value={data.channel_name || ""}
                    onChange={(e) => onHandleChange(e)}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box p={1}>
                  <InputLabel>
                    Select Channel Type<span className="required-span">*</span>
                  </InputLabel>
                  <SelectCmp
                    styles={selectStyles}
                    value={selectedWhitelistChannel || null}
                    options={whitelistchannelOptions}
                    placeholder="Select Channel Type"
                    onChange={(e) =>
                      onHandleChange({
                        target: { name: "channel_type", value: e.value },
                      })
                    }
                  />
                </Box>
                <Box p={1}>
                  <InputLabel>
                    URL<span className="required-span">*</span>
                  </InputLabel>
                  <CssTextField
                    variant="outlined"
                    name="URL"
                    fullWidth
                    placeholder={`Enter URL`}
                    size="small"
                    value={data.URL || ""}
                    onChange={(e) => onHandleChange(e)}
                  />
                </Box>
              </Grid>
            </>
          )}

          <Grid item xs={12} sm={6}>
            <Box
              p={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <StyledButton onClick={onSubmitForm}>
                <SaveIcon style={{ marginRight: "8px", fontSize: 17 }} /> Submit
              </StyledButton>
            </Box>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <h2 className="sub-heading">Your {heading} History</h2>
      </Grid>

      <Grid item xs={12}>
        <Box mt={4}>
          <TableContainer component={Paper}>
            <Table className="universal-table">
              <TableHead>
                <TableRow>
                  {/* {toolType === "ugc" && <TableCell>Claim Id</TableCell>} */}
                  {toolType !== "whitelist" && (
                    <>
                      <TableCell>Release Title</TableCell>
                      <TableCell>Audio Title</TableCell>
                    </>
                  )}
                  {toolType === "whitelist" && (
                    <>
                      <TableCell>Platform</TableCell>
                      <TableCell>Channel Type</TableCell>
                      <TableCell>Channel Name</TableCell>
                    </>
                  )}
                  {toolType === "ugc" && <TableCell>Policy</TableCell>}
                  <TableCell>Status</TableCell>
                  <TableCell>Date</TableCell>
                  {toolType === "ugc" && <TableCell>URLs</TableCell>}
                  {toolType === "whitelist" && <TableCell>URL</TableCell>}
                </TableRow>
              </TableHead>

              <TableBody>
                {Array.isArray(dataHistory) && dataHistory.length
                  ? dataHistory.map((item, index) => {
                      return (
                        <TableRow key={index} hover>
                          {toolType === "whitelist" && (
                            <>
                              <TableCell>{item.platform || ""}</TableCell>
                              <TableCell>{item.channel_type || ""}</TableCell>
                              <TableCell>{item.channel_name || ""}</TableCell>
                            </>
                          )}
                          {toolType !== "whitelist" && (
                            <>
                              <TableCell>{item.release_title || ""}</TableCell>
                              <TableCell>{item.audio_title || ""}</TableCell>
                            </>
                          )}
                          {toolType === "ugc" && (
                            <TableCell>{item.policy}</TableCell>
                          )}
                          <TableCell align="left">
                            <p>
                              {item.status === "in_review" ? (
                                <LightTooltip title="In Review">
                                  <AccessTimeIcon />
                                </LightTooltip>
                              ) : item.status === "rejected" ? (
                                <LightTooltip title="Rejected">
                                  <CancelIcon style={{ color: "red" }} />
                                </LightTooltip>
                              ) : (
                                <LightTooltip title="Approved">
                                  <CheckCircleIcon style={{ color: "green" }} />
                                </LightTooltip>
                              )}
                            </p>
                          </TableCell>
                          <TableCell>{item.date || ""}</TableCell>
                          {toolType === "whitelist" && (
                            <TableCell>
                              <span
                                style={{
                                  color: "blue",
                                  cursor: "pointer",
                                  fontWeight: 500,
                                }}
                                onClick={() => window.open(item.URL, "_blank")}
                              >
                                Click To Open
                              </span>
                            </TableCell>
                          )}
                          {toolType === "ugc" && (
                            <TableCell>
                              {item.url && !!item.url.length ? (
                                <span
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    fontWeight: 500,
                                  }}
                                  onClick={() =>
                                    renderModalViewContent("urls", item.url)
                                  }
                                >
                                  {item.url.length} URL
                                </span>
                              ) : (
                                <span>No URL</span>
                              )}
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
            <Pagination
              className="table-pagination"
              count={totalPages}
              showFirstButton
              showLastButton
              onChange={onPageChange}
              page={filters.page || 0}
            />
          </TableContainer>
        </Box>
      </Grid>
      <CustomShowModal
        open={guidelinesOpen}
        handleClose={() => setGuidelinesOpen(false)}
        maxWidth="sm"
        title="GUIDELINES"
      >
        {guidelinesToolsArray.map((item, key) => {
          return (
            <div style={{ display: "flex", padding: 5 }} key={key}>
              {key !== 0 ? (
                <span style={{ fontWeight: 600, marginRight: 5 }}>{key}.</span>
              ) : null}
              <p> {item}</p>
            </div>
          );
        })}
      </CustomShowModal>

      <CustomShowModal
        open={!!modalViewType.type}
        handleClose={() => setModalViewType({ type: "", urls: [] })}
        maxWidth="sm"
        title={modalViewType.type === "moods" ? "Select Moods" : "Add Url(s)"}
        description={
          toolType === "ugc"
            ? "Please remove '&feature=youtu.be' from your URL or the claim will not be released."
            : ""
        }
      >
        {generateModalContent(modalViewType, onChangeUrls, onAddUrls)}
      </CustomShowModal>

      <CustomShowModal
        open={modalContentView.show}
        handleClose={() =>
          setModalContentView({ show: false, component: null })
        }
        maxWidth="sm"
        title="View"
      >
        {modalContentView.component}
      </CustomShowModal>
      <CustomShowModal
        open={viewDetailsModal}
        handleClose={() => setViewDetailsModal(false)}
        maxWidth="sm"
        title={detailsData?.release_title || "Details"}
      >
        {toolType === "playlist" && (
          <div>
            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Artwork Assets:</strong>
              <br />
              <a href={detailsData?.artwork_asset}>
                {detailsData?.artwork_asset}
              </a>
            </p>

            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Additional Assets:</strong>
              <br />
              <a href={detailsData?.additional_assets}>
                {detailsData?.additional_assets}
              </a>
            </p>
            <strong>Moods:</strong>
            <ul>
              {detailsData?.moods.map((item) => {
                return <li>{item}</li>;
              })}
            </ul>
            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Your Pitch:</strong>
              <br />
              {detailsData?.why_pitch}
            </p>

            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Quick Pitch:</strong>
              <br />
              {detailsData?.quick_pitch}
            </p>

            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Additional Information:</strong>
              <br />
              {detailsData?.additional_info}
            </p>
          </div>
        )}

        {toolType === "lyrics" && (
          <div>
            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Publishing rights:</strong>
              <br />
              {detailsData?.p_rights}
            </p>

            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>ISWC:</strong>
              <br />
              {detailsData?.iswc}
            </p>
            {/* <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <a
                href={detailsData?.lrc_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>Download LRC</strong>
              </a>
            </p> */}

            <p style={{ whiteSpace: "break-spaces", paddingBottom: "5px" }}>
              <strong>Lyrics:</strong>
              <br />
              {detailsData?.lyrics}
            </p>
          </div>
        )}
      </CustomShowModal>
    </Grid>
  );
}

const generateModalContent = (viewType, onChangeUrls, onAddUrls) => {
  const { type = "", urls = [] } = viewType;
  return (
    <Box>
      {type === "moods" ? (
        <>
          <Box style={{ gap: "10px" }} display="flex" flexWrap="wrap">
            {moodsOptions.map((item) => {
              const isSelected = urls.includes(item);
              if (isSelected) {
                return (
                  <Chip
                    label={item}
                    onDelete={() => onChangeUrls("delete", type, item, null)}
                    color="primary"
                  />
                );
              }
              return (
                <Chip
                  label={item}
                  onClick={() => onChangeUrls("update", type, item, null)}
                />
              );
            })}
          </Box>
          <Box mt={3} textAlign="center">
            {urls.length ? <span>{urls.length} Moods selected</span> : null}
          </Box>
        </>
      ) : (
        urls.map((item, index) => {
          const isValid = isValidUrl(item);
          return (
            <Box
              key={index}
              mb={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <CssTextField
                variant="outlined"
                fullWidth
                placeholder={`Enter url ${index + 1}`}
                size="small"
                value={item}
                error={!isValid}
                onChange={(e) =>
                  onChangeUrls("update", type, e.target.value, index)
                }
              />
              {urls.length - 1 !== index || index > 8 || !isValid ? (
                <RemoveIcon
                  className="add-icon-button delete"
                  onClick={() => onChangeUrls("delete", type, null, index)}
                />
              ) : (
                <AddIcon
                  className="add-icon-button"
                  onClick={() => onChangeUrls("add", type, null, null)}
                />
              )}
            </Box>
          );
        })
      )}
      <Box mt={3} display="flex" justifyContent="center">
        <StyledButton onClick={onAddUrls}>Save</StyledButton>
      </Box>
    </Box>
  );
};
